"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenVeryficationMutation = exports.tokenAuthMutation = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const auth_1 = require("../fragments/auth");
exports.tokenAuthMutation = graphql_tag_1.default `
  ${auth_1.userFragment}
  mutation TokenAuth($email: String!, $password: String!) {
    tokenCreate(email: $email, password: $password) {
      token
      errors {
        field
        message
      }
      user {
        ...User
      }
    }
  }
`;
exports.tokenVeryficationMutation = graphql_tag_1.default `
  ${auth_1.userFragment}
  mutation VerifyToken($token: String!) {
    tokenVerify(token: $token) {
      payload
      user {
        ...User
      }
    }
  }
`;
//# sourceMappingURL=auth.js.map